/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FunctionMaturityItem
 */
export interface FunctionMaturityItem {
    /**
     * 
     * @type {string}
     * @memberof FunctionMaturityItem
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FunctionMaturityItem
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FunctionMaturityItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof FunctionMaturityItem
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof FunctionMaturityItem
     */
    csfFunction?: string;
    /**
     * 
     * @type {string}
     * @memberof FunctionMaturityItem
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof FunctionMaturityItem
     */
    currentMaturity?: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionMaturityItem
     */
    targetMaturity?: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionMaturityItem
     */
    currentTier?: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionMaturityItem
     */
    targetTier?: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionMaturityItem
     */
    maturityScore?: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionMaturityItem
     */
    progress?: number;
    /**
     * 
     * @type {string}
     * @memberof FunctionMaturityItem
     */
    owner?: string;
}

/**
 * Check if a given object implements the FunctionMaturityItem interface.
 */
export function instanceOfFunctionMaturityItem(value: object): value is FunctionMaturityItem {
    return true;
}

export function FunctionMaturityItemFromJSON(json: any): FunctionMaturityItem {
    return FunctionMaturityItemFromJSONTyped(json, false);
}

export function FunctionMaturityItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): FunctionMaturityItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'category': json['category'] == null ? undefined : json['category'],
        'csfFunction': json['csfFunction'] == null ? undefined : json['csfFunction'],
        'status': json['status'] == null ? undefined : json['status'],
        'currentMaturity': json['currentMaturity'] == null ? undefined : json['currentMaturity'],
        'targetMaturity': json['targetMaturity'] == null ? undefined : json['targetMaturity'],
        'currentTier': json['currentTier'] == null ? undefined : json['currentTier'],
        'targetTier': json['targetTier'] == null ? undefined : json['targetTier'],
        'maturityScore': json['maturityScore'] == null ? undefined : json['maturityScore'],
        'progress': json['progress'] == null ? undefined : json['progress'],
        'owner': json['owner'] == null ? undefined : json['owner'],
    };
}

export function FunctionMaturityItemToJSON(json: any): FunctionMaturityItem {
    return FunctionMaturityItemToJSONTyped(json, false);
}

export function FunctionMaturityItemToJSONTyped(value?: FunctionMaturityItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'category': value['category'],
        'csfFunction': value['csfFunction'],
        'status': value['status'],
        'currentMaturity': value['currentMaturity'],
        'targetMaturity': value['targetMaturity'],
        'currentTier': value['currentTier'],
        'targetTier': value['targetTier'],
        'maturityScore': value['maturityScore'],
        'progress': value['progress'],
        'owner': value['owner'],
    };
}

